import { z } from 'zod';

import { SCHEMAS } from './base';

export const loginPhoneSchema = z.object({
  phoneCode: SCHEMAS.authPhoneCode,
  phoneNumber: SCHEMAS.authPhoneNumber,
});

export const signupPhoneSchema = z.object({
  phoneCode: SCHEMAS.authPhoneCode,
  phoneNumber: SCHEMAS.authPhoneNumber,
});

export type LoginPhoneData = z.infer<typeof loginPhoneSchema>;
export type SignupPhoneData = z.infer<typeof signupPhoneSchema>;
